export const FOOTER_HEIGHT = "201px";
export const FOOTER_HEIGHT_MOBILE = "430px";

export const CONTAINER_MAX_WIDTH = "1240px";

export const ROYALTIES_MAX_WIDTH = "560px";
